/** Sent to the server in the "action" command. */
export enum ActionType {
  Play,
  Discard,
  ColorClue,
  RankClue,
  GameOver,
}
